/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/ 
var styles = ["[_nghost-%COMP%] {\n  display: inline-block; }\n\n.inline[_ngcontent-%COMP%] {\n  display: inline-block; }\n\n .ngx-datepicker-calendar-container {\n  z-index: 10; }\n   .ngx-datepicker-calendar-container .main-calendar-container .main-calendar-days .day-unit {\n    width: 14.28% !important; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/date-range-picker/date-range-picker.component.scss.shim.ngstyle.js.pre-build-optimizer.js